import { BaseApi } from './BaseApi';
import { ISuggestion } from '@/typings/api/suggestions';

// export interface IWarehousesApiResponseList
//   extends IBaseApiResponseList<ISuggestion> {
//   collection: ISuggestion[];
// }

export class SuggestionsApi extends BaseApi<ISuggestion> {
  protected readonly endpoint = 'suggestions';

  /**
   *
   * @param query
   * @example 'positionCompany,positionEntrepreneur,credentialsType'
   */
  public getSuggestions(query: string) {
    const url = '';
    const params = { items: query };
    return this.request<ISuggestion[]>('GET', url, { params });
  }
}
